<template>
  <div class="modal" :class="[enableViewer ? 'is-active': 'animated slideOutUp']">
    <div class="modal-background"></div>
    <div class="modal-content animated slideInDown">
      <iframe v-if="isDoc" class="doc" width="100%" height="100%" :src="`https://docs.google.com/gview?url=${cvUrl}&embedded=true`"></iframe>
      <iframe  v-else class="doc" width="100%" height="100%" :src="cvUrl+'#zoom=100'" />
    </div>
    <button class="modal-close is-large" aria-label="close" @click="close"></button>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState('cvViewer', ['enableViewer', 'cvUrl']),
    isDoc () {
      const ext = this.documentType
      if (ext === 'doc' || ext === 'docx') {
        return true
      }
    },
    documentType () {
      if (this.cvUrl !== null) {
        return this.cvUrl.split('.').pop()
      }
    }
  },
  methods: {
    close () {
      this.$store.commit('cvViewer/setEnableViewer', false)
      this.$store.commit('cvViewer/setCVUrl', null)
    }
  }
}
</script>

<style lang="scss" scoped>
  .modal-content {
    width: 90vw;
  }
  .doc {
    width: 100%;
    padding: 0.5rem;
    border-radius: 0.25rem;
    height: calc(100vh - 45px);
    background: #fff;
  }
  .loading {
    width: 100%;
    border-radius: 0.25rem;
    height: calc(100vh - 45px);
    background: #fff;
    padding: 40vh 0;
    text-align: center;
    font-size: 20px;
  }
  .is-large.delete, .is-large.modal-close {
      height: 42px;
      max-height: 42px;
      max-width: 42px;
      min-height: 42px;
      min-width: 42px;
      width: 42px;
  }

.modal-close::before, .modal-close::after {
  /* close icon created in CSS */
  content: '';
  position: absolute;
  top: 12px;
  right: 25px;
  height: 2.5px;
  width: 24px;
  background-color: #ccc;
  backface-visibility: hidden;
}

.modal-close::before {
  transform: rotate(45deg);
}

.modal-close::after {
  transform: rotate(-45deg);
}

.modal-close:hover::before, .modal-close:hover::after {
  transition: transform 0.3s;
}

.modal-close:hover::before {
  transform: rotate(220deg);
}

.modal-close:hover::after {
  transform: rotate(135deg);
}
.modal-close {
  background: none;
  background-color: none;
}
</style>



// WEBPACK FOOTER //
// src/components/general/cv-viewer.vue